import {
  TENANT_BOOTSTRAP_ERROR_CODES,
  TenantBootstrapError,
} from "./bootstrapErrors";

const VALID_TENANT_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const normalizeTenantSlug = (value) =>
  String(value || "").trim().toLowerCase();

export const getTenantSlugFromPath = (pathname) => {
  const [firstSegment] = String(pathname || "")
    .split("/")
    .filter(Boolean);

  return normalizeTenantSlug(firstSegment);
};

export const resolveTenantSlugFromPath = (pathname) => {
  const tenantSlug = getTenantSlugFromPath(pathname);

  if (!tenantSlug || !VALID_TENANT_SLUG_PATTERN.test(tenantSlug)) {
    throw new TenantBootstrapError(
      TENANT_BOOTSTRAP_ERROR_CODES.INVALID_TENANT_SLUG,
      "Tenant slug is missing or invalid.",
      { pathname, tenantSlug }
    );
  }

  return tenantSlug;
};

